module.exports = __webpack_public_path__ + "static/media/warrenty.5f081447.png";